import {useDispatch, useSelector} from "react-redux";
import {useMutation} from "react-query";
import {toast} from "react-toastify";
import {withTranslation} from "react-i18next";

import logger from "../../utility/logger.mjs";
import {locationDeleted, selectCurrentProjectLocations} from "../../data/locationsSlice";
import {dropLocation} from "../../server/serverOperation";
import {AlertWarning} from "../Alert";
import useConfirm from "../ConfirmDialog";
import {findById} from "../../utility/function.mjs";

import {useGridApiContext, GridActionsCellItem} from "@mui/x-data-grid-pro";
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import {Tooltip} from "@mui/material";
import {useItemNameTranslator} from "../../utility/useItemNameTranslator";

const PureLocationDeleteButton = ({t,locationId, showInMenu}) => {
  const translateNames = useItemNameTranslator();
  const dispatch = useDispatch();
  const apiRef = useGridApiContext();
  const confirm = useConfirm();
  const locations = useSelector(selectCurrentProjectLocations)
  const location = findById(locations, locationId);
  // get recursively all ids of location's subchildrens
  const childrenIds = (function getChildrenIdsRecursive(locationChildrenIds){
      if(locationChildrenIds == null || locationChildrenIds.length === 0){
        return [];
      }
      let res = locationChildrenIds;
      for(const childId of locationChildrenIds){
        const childLocation = findById(locations, childId);
        res = res.concat(getChildrenIdsRecursive(childLocation.children));
      }
    return res;
    })(location?.children);
  const locationNames = [location?.name].concat(childrenIds?.map(childId => findById(locations, childId)?.name));

  const {mutate:mutateDropLocation} = useMutation(
    dropLocation, // parameter {locationIds}
    {
      onSuccess: (data) => {
        const deletedLocationIds = [locationId, ...childrenIds];
        // Move devices at the deleted locations to the top.
        const deviceIds = deletedLocationIds.reduce((acc,curId) => acc.concat(apiRef.current.getRow(curId).devices), []);
        const deviceUpdateParamArray = deviceIds.map(deviceId => ({id:`d${deviceId}`, path: [`d${deviceId}`]}));
        const locationUpdateParamArray = deletedLocationIds.map(locationId => ({id:locationId, _action: 'delete' }));
        apiRef.current.updateRows([...deviceUpdateParamArray, ...locationUpdateParamArray]);
        dispatch(locationDeleted({ids:deletedLocationIds}));
        toast.success(t("locations-deleted-info", {locationNames: translateNames(locationNames)}), {
          toastId: `locations-deleted-${location.id}`
        });
      },
      onError: (error) => {
        toast.error(t("locations-delete-error", {locationNames: translateNames(locationNames)}), {
          toastId: "locations-delete-error"
        });
        logger.error("updateLocation", error);
      }
    }
  );
  
  async function handleLocationDeleteClick(){
    console.log("handleLocationDeleteClick", location.name, childrenIds, translateNames(location.name), childrenIds?.length)
    const confirmationMessage =
      <AlertWarning
        text={
          t("location-delete-confirmation",
            {
              locationName: translateNames(location.name),
              sublocationCount: childrenIds?.length
            }
          )
        }
        title={false}
      />
    const confirmationOk = await confirm({
      children: confirmationMessage,
      okButtonText: "ok",
      cancelButtonText: "cancel"
    });
    if(confirmationOk){
      mutateDropLocation({locationIds: [locationId, ...childrenIds]});
    }
  }

  if(showInMenu){
    return (
      <GridActionsCellItem 
        showInMenu
        label={t('delete-location')}
        icon={<DeleteForeverOutlinedIcon />} 
        onClick={handleLocationDeleteClick} 
      />
    )
  }

  return (
    <Tooltip title={t('delete-location')} >
      <GridActionsCellItem 
        icon={<DeleteForeverOutlinedIcon />} 
        onClick={handleLocationDeleteClick} 
      />
    </Tooltip>
  )
};
export default withTranslation()(PureLocationDeleteButton);
